import { render, staticRenderFns } from "./MaskContainer.vue?vue&type=template&id=b52a8262"
import script from "./MaskContainer.vue?vue&type=script&lang=ts"
export * from "./MaskContainer.vue?vue&type=script&lang=ts"
import style0 from "./MaskContainer.vue?vue&type=style&index=0&id=b52a8262&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports